var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleTechInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.642,
    height: 15.279,
    viewBox: "0 0 13.642 15.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "event-schedule",
    transform: "translate(-6 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M23.866,29.731a4.366,4.366,0,1,1,4.366-4.366A4.366,4.366,0,0,1,23.866,29.731Zm0-7.64a3.274,3.274,0,1,0,3.274,3.274A3.274,3.274,0,0,0,23.866,22.091Z",
    transform: "translate(-8.589 -11.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M31.413,30.82,30,29.406V27h1.091v1.959l1.091,1.091Z",
    transform: "translate(-15.269 -15.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M19.1,5.183a1.091,1.091,0,0,0-1.091-1.091H15.822V3H14.731V4.091H10.366V3H9.274V4.091H7.091A1.091,1.091,0,0,0,6,5.183V16.1a1.091,1.091,0,0,0,1.091,1.091H9.274V16.1H7.091V5.183H9.274V6.274h1.091V5.183h4.366V6.274h1.091V5.183h2.183V8.457H19.1Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTechInterview);
export default __webpack_public_path__ + "static/media/Schedule Tech Interview .35afdaa8e301c565689488e324d74e7d.svg";
export { ForwardRef as ReactComponent };